import { useMutation, useQuery } from "@tanstack/react-query";
import { auditApiService } from "modules/Audit/api/audit.api";
import { LoginPayload } from "../helper/audit.types";

export const useAuditService = (
  isModuleDropdownEnabled: boolean = false,
  loginPayload?: LoginPayload,
  isLoginAuditEnabled: boolean = false,
) => {
  const ModuleDropdownQuery = useQuery({
    queryKey: ["audit-module-dropdown"],
    queryFn: () => auditApiService.getModuleDropdownData(),
    enabled: isModuleDropdownEnabled,
  });

  const SelectAllMutation = useMutation({
    mutationFn: (payload: any) =>
      auditApiService.getAuditSelectAllData(payload),
  });

  const LoginSelectAllQuery = useQuery({
    queryKey: [
      "audit-login-select-all",
      loginPayload?.currentpage,
      loginPayload?.pagesize,
      loginPayload?.ispagination,
      loginPayload?.fromdate,
      loginPayload?.todate,
      loginPayload?.useractivity,
    ],
    queryFn: () => auditApiService.getLoginSelectAllData(loginPayload),
    enabled: isLoginAuditEnabled,
  });

  const RecordDropdownMutation = useMutation({
    mutationFn: (payload: any) =>
      auditApiService.getRecordDropdownData(payload),
  });

  const ChildModuleDropdownMutation = useMutation({
    mutationFn: (payload: any) =>
      auditApiService.getChildModuleDropdownData(payload),
  });

  return {
    ModuleDropdownQuery,
    SelectAllMutation,
    LoginSelectAllQuery,
    RecordDropdownMutation,
    ChildModuleDropdownMutation,
  };
};
